<h2 mat-dialog-title>Contributing</h2>

<mat-dialog-content class="mat-typography">

  @switch (show) {

  @case ('loading') {
  <div class="loading">
    <video width="200" height="200" loop autoplay>
      <source src="assets/loading-animations/loading.mp4" type="video/mp4">
      Loading...
    </video>

    <mat-progress-bar class="loading-bar" [color]="color" [mode]="mode">
    </mat-progress-bar>
  </div>
  }

  @case ('success') {
  <div class="loading">
    <video width="200" height="200" autoplay>
      <source src="assets/loading-animations/success.mp4" type="video/mp4">
      Loading...
    </video>

    <h2>Submission success</h2>

    <p>
      Thank you for submitting your observation to the EUROVOLC project.
      We really appreciate you taking the time to support our
      <a href="https://eurovolc.eu/">European volcanological community</a>.
    </p>

    <p>
      Your observation will be moderated by the EUROVOLC team within 24 hours
      to confirm that it is suitable for publication.
      It will then be made available on the EUROVOLC tool for other users to view.
    </p>
  </div>
  }

  @case ('error') {
  <div>
    <p>There was a problem submitting your observation. Please try again.</p>
  </div>
  }

  }

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>OK</button>
</mat-dialog-actions>